import * as React from "react";
import { Text, useFieldState, FieldProps, useFieldApi } from "informed";
import * as classNames from 'classnames';
import { inputClasses } from "../validation/ValidationClasses";
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";

interface TextBoxProps<V, VS> extends FieldProps<V, VS> {
    id?: string;
    field: string;
    inputAddon?: React.ReactNode;
}
export const TextBox = <V, VS>({ id, field, inputAddon, ...props }: TextBoxProps<V, VS>) => {
    const fieldApi = useFieldApi(field);

    const divClasses = classNames({
        "input-group": inputAddon !== undefined,
        "field-block-error": fieldApi.getError(),
        "field-block-valid": !fieldApi.getError(),
    })

    return (
        <>
            <div className={divClasses}>
                <Text<V, VS>
                    id={id}
                    data-automationid={replaceDotsWithHyphens(field)}
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
                {inputAddon ? <span className="input-group-addon">{inputAddon}</span> : null}
            </div>
            {fieldApi.getError() ? <span data-automationid="ValidationError" className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );

}
